import { createFileRoute } from '@tanstack/react-router';
import { Trans, useLingui } from '@lingui/react/macro';
import { SparklesIcon } from 'lucide-react';
import { Button } from '@pantry/ui';

export const Route = createFileRoute('/_app/upgrade')({
  component: UpgradePage,
});

function UpgradePage() {
  const { t } = useLingui();

  return (
    <div className="flex flex-col items-center justify-center py-24 text-center gap-6 max-w-md mx-auto">
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-amber-100 dark:bg-amber-900/40">
        <SparklesIcon className="h-8 w-8 text-amber-600 dark:text-amber-400" />
      </div>
      <div>
        <h1 className="font-display text-2xl font-semibold text-foreground mb-2">
          {t({ message: 'Premium Plans', context: 'page_title' })}
        </h1>
        <p className="text-muted-foreground">
          <Trans>Premium subscription plans are coming soon. Stay tuned!</Trans>
        </p>
      </div>
      <Button variant="outline" onClick={() => window.history.back()}>
        <Trans context="action_button">Go Back</Trans>
      </Button>
    </div>
  );
}
